import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/inspection/")({
  beforeLoad: () => {
    throw redirect({
      to: "/inspection/queue",
    });
  },
  component: () => null,
});
